var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('div',{attrs:{"id":"myCar"}},[_c('three-rotate',{attrs:{"imgsPath":"rotateImg/pro1","totalNum":61}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }